import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';

import { GameService } from '../../game/services/game.service';
import { ThemeService } from '../../shared/theme/services/theme.service';
import { TranslationService } from '../../translation/services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class DefaultThemeResolver implements Resolve<any> {

  /**
   * Constructor
   *
   * @param translationService
   * @param authService
   * @param {GameService} gameService
   * @param themeService
   * @param meta
   */
  public constructor(
    private translationService: TranslationService,
    private authService: AuthService,
    private gameService: GameService,
    private themeService: ThemeService,
    private meta: Meta,
  ) {
  }

  /**
   * Resolve
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @return {Observable<boolean> | Promise<boolean> | any}
   */
  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | any {
    // Grab the default theme from the meta tags and notify the theme service.
    const theme = this.meta.getTag('name=application-theme').content;
    this.themeService.setTheme(theme);

    if (this.meta.getTag('name=custom-theme') !== null) {
      this.themeService.customThemeChangeSubject.next(this.themeService.customTheme);
    }
  }
}
